import {RestService} from "@/services/rest/RestService";
import {ExportAPIApi} from "@/api/pharma-cpc-export";
import {CustomerContext} from "@/context/CustomerContext";
import {AxiosResponse} from "axios";
import {downloadBlobAsFile} from "@/helpers/functions/file";
import {CatalogProductsCriteriaBodyRestDtoModel} from "@/models/criteria/CatalogProductsCriteriaBodyRestDtoModel";
import {
    CatalogProductsExportRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CatalogProductsExportRestDtoModel";

export class CpcExportRestService extends RestService {

    private apiService: ExportAPIApi;

    protected constructor() {
        super();

        this.apiService = new ExportAPIApi(this.getDpAxiosV2Instance(), undefined, this.getConfig().cpcUrl);
    }

    public async exportCustomerCatalogDetailsXlsx(criteria: CatalogProductsCriteriaBodyRestDtoModel): Promise<void> {
        const body = CatalogProductsExportRestDtoModel.createWithDefaults();
        body.criteria = criteria;

        const acceptedMimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const exportType = 'EXPORT_CATALOG_PRODUCTS';
        const catalogCustomerCode = CustomerContext.getCustomerCode();
        const response: AxiosResponse<any, any> = await this.apiService.exportCustomerCatalogDetails(body, acceptedMimeType, catalogCustomerCode, exportType);

        const filename: string = 'products.xlsx'; // Ensure sanitized filename
        downloadBlobAsFile(response.data, filename);
    }

}
